import React from "react";
import { useToast } from "../Contexts/ToastContext";
import "../css/Common/Toast.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faExclamationCircle,
  faInfoCircle,
  faSpinner
} from "@fortawesome/free-solid-svg-icons";

const icons = {
  success: faCheckCircle,
  error: faExclamationCircle,
  info: faInfoCircle,
  processing: faSpinner
};

const Toast = () => {
  const { toast, clearToast } = useToast();

  if (!toast) return null;

  const handleClick = () => {
    if (toast.type === "error") clearToast();
  };

  return (
    <div className={`toast toast-${toast.type}`} onClick={handleClick}>
      <FontAwesomeIcon
        icon={icons[toast.type] || faInfoCircle}
        className={`toast-icon ${toast.type === "processing" ? "spin" : ""}`}
      />
      <div className="toast-message">{toast.message}</div>
    </div>
  );
};

export default Toast;
